import mirrorKey from 'mirrorkey'

const sessionStorageKeys = mirrorKey({
  TOKEN: null,
  EMAIL: null,
})

export default sessionStorageKeys